import React from "react";
import propTypes from "prop-types";
import { Header, Form, Input } from "semantic-ui-react";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { GET } from "../../frameworks/HttpClient";
import { URL_COMMON } from "../../constances";
import ChemicalInputForm from "./ChemicalInputForm";

let targetId = 1;
const LabPondInput = React.forwardRef((props, ref) => {
	const [others, setOthers] = React.useState(
		(props.initialOthersModal.length > 0) 
		? props.initialOthersModal
		: [{id: 1, chemical: "", amount: ""}]
	);
	const [trigger, setTrigger] = React.useState(false);
	const [options, setOptions] = React.useState([]);
	const chemicalRef = React.useRef([]);

	const model = { ...(props.initialModel || defaultInitialModal) };

	let validationSchema = {
		water: Yup.number().notRequired(),
		la: Yup.number().notRequired(),
		dap: Yup.number().notRequired(),
		nh3: Yup.number().notRequired(),
		tz: Yup.number().notRequired(),
		washer: Yup.number().notRequired(),
	}

	const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: model,
    validationSchema: Yup.object(validationSchema),
    onSubmit: props.onSubmit,
  });

	const fetchOptions = async () => {
		try {
			const response = await GET(`${URL_COMMON.CHEMICAL}`);
			setOptions(
        response.data.map(item => {
          return {
            key: item.id, 
            value: item.name, 
            text: item.name
          }
        })
      );
		} catch (error) {}
	}
	
	const handleAddChemical = () => {
		targetId = targetId + 1;
		setOthers([
			...others,
			{id: targetId, chemical: "", amount: ""}
		])
	}

	const handleDeleteChemical = (data) => {
		let myList = others;
		let index = 0;
		for (let i = 0; i < myList.length; i++) {
			if (myList[i].id === data.id) {
				index = i;
				break;
			}
		}
		
		if (index > 0) {
			myList.splice(index, 1);
			setOthers(myList);
			setTrigger(!trigger);
		}
	}

	React.useImperativeHandle(ref, () => ({ 
		formik,
		getOthers: () => {
			let list = []
			for (let index in others) {
				let value = chemicalRef.current[index].getValue()
				if (value.chemical && (value.amount > 0)) {
					list.push(value);
				}
			}
			return list;
		}
	 }));

	React.useEffect(() => {
		targetId = props.initialOthersModal.length;
		formik.resetForm();
		fetchOptions();
	}, [])

	return (
		<div style={{...props.style}}>
			<Header as={"h3"} style={{marginLeft: 24}}>สารเคมีที่ต้องการเติมเพิ่ม</Header>
			<Form style={{textAlign: "right"}}>
				<Form.Group widths={"2"}>
					<Form.Field 
						style={{width: "55%"}}
						inline
						readOnly={props.readOnly}
						label={"น้ำ"}
						control={Input}
						placeholder={"0"} 
						type={"text"}
						name={"water"}
						error={formik.errors.water}
						value={formik.values.water}
						onChange={formik.handleChange}
					/>
					<Form.Field 
						style={{width: "55%"}}
						inline
						readOnly={props.readOnly}
						label={"La"}
						control={Input}
						placeholder={"0"} 
						type={"text"}
						name={"la"}
						error={formik.errors.la}
						value={formik.values.la}
						onChange={formik.handleChange}
					/>
				</Form.Group>

				<Form.Group widths={"2"}>
					<Form.Field 
						style={{width: "55%"}}
						inline
						readOnly={props.readOnly}
						label={"DAP"}
						control={Input}
						placeholder={"0"} 
						type={"text"}
						name={"dap"}
						error={formik.errors.dap}
						value={formik.values.dap}
						onChange={formik.handleChange}
					/>
					<Form.Field 
						style={{width: "55%"}}
						inline
						readOnly={props.readOnly}
						label={"NH3"}
						control={Input}
						placeholder={"0"} 
						type={"text"}
						name={"nh3"}
						error={formik.errors.nh3}
						value={formik.values.nh3}
						onChange={formik.handleChange}
					/>
				</Form.Group>

				<Form.Group widths={"2"}>
					<Form.Field 
						style={{width: "55%"}}
						inline
						readOnly={props.readOnly}
						label={"TZ"}
						control={Input}
						placeholder={"0"} 
						type={"text"}
						name={"tz"}
						error={formik.errors.tz}
						value={formik.values.tz}
						onChange={formik.handleChange}
					/>
					<Form.Field 
						style={{width: "55%"}}
						inline
						readOnly={props.readOnly}
						label={"น้ำล้าง"}
						control={Input}
						placeholder={"0"} 
						type={"text"}
						name={"washer"}
						error={formik.errors.washer}
						value={formik.values.washer}
						onChange={formik.handleChange}
					/>
				</Form.Group>

				{/* <ChemicalInput /> */}
				{others.map((data, index) => {
					return (
						<ChemicalInputForm
							ref={(el) => (chemicalRef.current[index] = el)}
							key={data.id} 
							readOnly={props.readOnly}
							options={options} 
							data={data} 
							canDelete={(index === 0) ? false : true}
							onAdd={handleAddChemical} 
							onDelete={handleDeleteChemical}
						/>
					)
				})}
			</Form>
		</div>
	)
});

const defaultInitialModal = {
	water: "",
	la: "",
	dap: "",
  nh3: "",
  tz: "",
	washer: "",
};

LabPondInput.defaultProps = {
	style: null,
	readOnly: false,
	initialModel: null,
	initialOthersModal: [],
}

LabPondInput.propTypes = {
	style: propTypes.object,
	readOnly: propTypes.bool,
	initialModel: propTypes.object,
	initialOthersModal: propTypes.array,
}

export default LabPondInput;